import { useEffect } from 'react';

import { useLazyGetApiDashboardByStudentIdQuery } from 'applications/GSP/shared/api/gsp';
import { useStudentId } from 'applications/GSP/shared/hooks/user';

export const useGetDashboard = () => {
  const studentId = useStudentId();
  const [getDashboard, { data, isLoading }] =
    useLazyGetApiDashboardByStudentIdQuery();

  useEffect(() => {
    if (studentId) {
      getDashboard({ studentId });
    }
  }, [getDashboard, studentId]);

  return { data, isLoading };
};
